import { paymentInstallments } from '../components/Methods/components/MethodsFlow/components/CreditCard/components/CardForm/data';

export const getPriceWithInstallments = (price, months) => {
  const installments = paymentInstallments.filter((payment) => {
    return payment.months === months;
  });
  return ((price * (1 + installments[0].taxe)) / months).toFixed(2);
};

export const getTotalPrice = (price, months) => {
  const totalPrice = price.split('$')[1];
  const priceDecimal = totalPrice.replace(',', '');
  let finalPrice = priceDecimal;
  if (months !== 0) {
    const priceByMonth = getPriceWithInstallments(priceDecimal, months);
    finalPrice = (priceByMonth * months).toFixed(2);
  }
  return finalPrice;
};
